// pkg148 — MightyAnalyzer™ landing (D-148b): top-level nav entry needs a client to route to, since the analyzer is client-scoped (/admin/clients/:id/discovery-analysis, pkg81); this page is PURE NAVIGATION — a type-to-filter picker over adminApi.listClients(), click → the existing analyzer page untouched; ethical walls stay server-enforced exactly as today (a blocked client's analyzer API 403s) — delivered 2026-08-16
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../utils/adminApi';

const META = 'Arial, sans-serif';
const NAVY = '#1E2761';

export default function AdminDiscoveryAnalysisLandingPage() {
  const navigate = useNavigate();
  const [clients, setClients] = useState(null); // null = loading
  const [error, setError] = useState('');
  const [filter, setFilter] = useState('');

  useEffect(() => {
    let alive = true;
    adminApi.listClients()
      .then((cs) => { if (alive) setClients(Array.isArray(cs) ? cs : []); })
      .catch(() => { if (alive) { setClients([]); setError('Could not load your client list. Refresh to try again.'); } });
    return () => { alive = false; };
  }, []);

  const shown = useMemo(() => {
    const list = clients || [];
    const q = filter.trim().toLowerCase();
    if (!q) return list;
    return list.filter((c) =>
      String(c.name || '').toLowerCase().includes(q) ||
      String(c.email || '').toLowerCase().includes(q));
  }, [clients, filter]);

  return (
    <div style={{ maxWidth: 720 }}>
      <h1 style={{ fontFamily: META, fontSize: 24, color: NAVY, margin: '0 0 4px' }}>
        MightyAnalyzer™
      </h1>
      <div style={{ fontFamily: META, fontSize: 14, color: '#555', margin: '0 0 18px' }}>
        Production analysis — turn the other side's document production into working reports.
        Pick the client whose matter you're analyzing.
      </div>

      {error && (
        <div style={{ fontFamily: META, fontSize: 13, color: '#8a1f1f', background: '#fbeaea', border: '1px solid #eccaca', borderRadius: 5, padding: '8px 12px', marginBottom: 12 }}>
          {error}
        </div>
      )}

      <input
        type="text"
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        placeholder="Search clients by name or email…"
        autoFocus
        style={{ width: '100%', boxSizing: 'border-box', fontFamily: META, fontSize: 14, padding: '9px 12px', border: '1px solid #c9cfdd', borderRadius: 5, marginBottom: 12 }}
      />

      {clients === null ? (
        <div style={{ fontFamily: META, fontSize: 13, color: '#888' }}>Loading clients…</div>
      ) : shown.length === 0 ? (
        <div style={{ fontFamily: META, fontSize: 13, color: '#888' }}>
          {filter.trim() ? 'No clients match that search.' : 'No clients yet — add a client first, then run the analyzer from here or from their file.'}
        </div>
      ) : (
        <div style={{ border: '1px solid #e3e7ef', borderRadius: 6, overflow: 'hidden' }}>
          {shown.map((c, i) => (
            <button
              key={c.id}
              type="button"
              onClick={() => navigate(`/admin/clients/${c.id}/discovery-analysis`)}
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                width: '100%', boxSizing: 'border-box', textAlign: 'left',
                background: '#fff', border: 'none',
                borderTop: i === 0 ? 'none' : '1px solid #eef1f6',
                padding: '11px 14px', cursor: 'pointer', fontFamily: META,
              }}
              onMouseOver={(e) => { e.currentTarget.style.background = '#f6f8fc'; }}
              onMouseOut={(e) => { e.currentTarget.style.background = '#fff'; }}
            >
              <span style={{ fontSize: 14, color: '#222' }}>
                {c.name || '(unnamed client)'}
                {c.email ? <span style={{ fontSize: 12, color: '#999', marginLeft: 8 }}>{c.email}</span> : null}
              </span>
              <span style={{ fontSize: 12, color: NAVY }}>Analyze →</span>
            </button>
          ))}
        </div>
      )}

      <div style={{ fontFamily: META, fontSize: 12, color: '#999', marginTop: 14 }}>
        You can also open the analyzer from any client's file.
      </div>
    </div>
  );
}
